import { render, staticRenderFns } from "./app-content-block.vue?vue&type=template&id=dd144636&functional=true&"
import script from "./app-content-block.vue?vue&type=script&lang=js&"
export * from "./app-content-block.vue?vue&type=script&lang=js&"
import style0 from "./app-content-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports